import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ListRequests } from './ListRequests';
import { AddEditRequest } from './AddEditRequest';
import { ViewRequest } from './ViewRequest';
import ProtectedRoute from '../PrivateRoute';

function Requests({ match }) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={ListRequests} />
            <Route path={`${path}/add`} component={AddEditRequest} />
            <Route path={`${path}/edit/:id`} component={AddEditRequest} />
            <Route path={`${path}/view/:id`} component={ViewRequest} />
        </Switch>
    );
}

export { Requests };